module.exports = __webpack_public_path__ + "static/media/barista.74f2e127.png";